// ** Initial State
import { dataUtils } from "../../../applyoo/js/dataUtils";
import { clearApplyooComponents } from "../../../applyoo/infrastructure/useApplyooComponent";

const initialState = {
    pageStructure: {},
    lstElements: [],
    lstElementsTree: [],
    pageCode: '',
    dicElementsFlatTree: {},
    lstElementsFlat: [],
    dicElementCommands: {},
    dicPageTemplates: {},
    latestPageInfo: {},
}

export const store_PageStructure = (state = initialState, action) => {
    switch (action.type) {
        // case 'CHANGE_STORE_PAGE_STRUCTURE':
        //     return { ...state, pageStructure: action.pageStructure, pageCode: action.pageCode }

        // case 'CHANGE_DIC_ELEMENTS_FLAT_TREE':
        //     return { ...state, dicElementsFlatTree: action.dicElementsFlatTree}

        case 'FREE_MEMORY':
            return {...state, initialState};

        case 'CACHE_PAGE_DATA':
            const { key, pageData } = action;
            const dicPageTemplates = { ...state.dicPageTemplates }
            dicPageTemplates[key] = pageData;
            return {...state,  dicPageTemplates, latestPageInfo: pageData};

        case 'CHANGE_LST_ELEMENTS':
            clearApplyooComponents()
            let arrElementsFlat = dataUtils.convertObjectToArray(action.dicElementsFlatTree);
            return { ...state, lstElements: action.lstElements,
                        pageCode: action.pageCode,
                        dicElementsFlatTree: action.dicElementsFlatTree,
                        pageStructure: action.pageStructure,
                        lstElementsFlat: arrElementsFlat }

        case 'CHANGE_MULTIPLE_ELEMENTS':
            let dicNewElementsFlatTree = { ...state.dicElementsFlatTree }

            for (const currModifiedElement of action.lstModifiedElements) {
                if (!!dicNewElementsFlatTree[currModifiedElement.ElementGuid]) {
                    dicNewElementsFlatTree[currModifiedElement.ElementGuid] = {...currModifiedElement}
                }
            }

            return { ...state, dicElementsFlatTree: dicNewElementsFlatTree }

        case 'CHANGE_ELEMENT':
            let dicElementsFlatTree = { ...state.dicElementsFlatTree }
            dicElementsFlatTree[action.CurrElement.ElementGuid] = action.CurrElement;

            let dicCommands = { ...state.dicElementCommands }
            dicCommands[action.CurrElement.ElementGuid] = null; //action.commandAction;

            return { ...state, dicElementsFlatTree: dicElementsFlatTree, dicElementCommands: dicCommands } //,lstElementsFlat: lstElementsFlat}

        case 'ADD_VIRTUAL_UI_ELEMENTS':
            let tempDicElement = dataUtils.convertArrayToDicObject(action.lstElements, 'ElementGuid')
            return { ...state, dicElementsFlatTree: { ...state.dicElementsFlatTree, ...tempDicElement } }

        case 'REMOVE_VIRTUAL_UI_ELEMENTS':
            let tempDicElementsFlatTree = { ...state.dicElementsFlatTree };

            for (let dicElementsFlatTreeKey in state.dicElementsFlatTree) {

                if (dicElementsFlatTreeKey.startsWith("virtualField_")) {
                    delete tempDicElementsFlatTree[dicElementsFlatTreeKey]
                }
            }
            return { ...state, dicElementsFlatTree: tempDicElementsFlatTree }

        case 'TRIGGER_ELEMENT_COMMANDS':
            dicCommands = { ...state.dicElementCommands }
            dicCommands[action.ElementGuid] = action.commandAction;
            return { ...state, dicElementCommands: dicCommands }

        // case 'CLEAR_PREV_PAGE_INFO':
        //     return {...initialState}

        case 'UPDATE_BOOKMARKED':
            let objectToUpdate

            // ** find & update object
            state.suggestions.find(item => {
                if (item.id === action.id) {
                    item.isBookmarked = !item.isBookmarked
                    objectToUpdate = item
                }
            })

            // ** Get index to add or remove bookmark from array
            const bookmarkIndex = state.bookmarks.findIndex(x => x.id === action.id)

            if (bookmarkIndex === -1) {
                state.bookmarks.push(objectToUpdate)
            } else {
                state.bookmarks.splice(bookmarkIndex, 1)
            }

            return { ...state }
        default:
            return state
    }
}

// export default store_PageStructure
